module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kd-Ld.ffc9fc9d.png";